<template>
  <div class="d-inline-block">
    <v-tooltip
      :bottom="tooltipPosition=== 'bottom'"
      :color="color"
      :disabled="!tooltip"
      :left="tooltipPosition=== 'left'"
      :right="tooltipPosition=== 'right'"
      :top="tooltipPosition=== 'top'"
      max-width="350"
    >
      <template #activator="{on}">
        <v-chip
          :class="[{'pl-0 pr-1': isDense && !!icon && !iconOnly, 'pl-0 pr-2': !isDense && !!icon && !iconOnly, 'px-1': isDense && !icon && !iconOnly, 'px-2': !isDense && !icon && !iconOnly, 'px-0': iconOnly}, 'mx-1', chipClass]"
          :color="color"
          :small="dense"
          :style="[{cursor: 'inherit'}, chipMinWidth, chipStyle]"
          :x-small="xDense"
          class="elevation-0"
          dark
          label
          v-on="{...on, ...$listeners}"
        >
          <v-avatar
            v-if="icon"
            :class="[isDense ? iconOnly ? 'mr-0' : 'mr-1' : iconOnly ? 'mr-0' : 'mr-2', avatarClass, {'darken-2': avatarColor === color}]"
            :color="avatarColor || color"
            :style="avatarSize"
            tile
          >
            <v-icon
              :class="iconClass"
              :color="iconColor"
              :size="iconSize"
              dark
            >
              {{ icon }}
            </v-icon>
          </v-avatar>

          <div
            v-if="!iconOnly"
            v-safe-html="label"
            :class="[labelClass]"
            :style="contrastColorStyle"
            style="width: 100%;"
          />
        </v-chip>
      </template>

      <template v-if="!!tooltip">
        <div v-safe-html="tooltip" />
      </template>
    </v-tooltip>
  </div>
</template>

<script>

import {getContrastColor} from '@/lib/color'

export default {
  name      : 'StatusChip',
  components: {},
  directives: {},
  mixins    : [],
  props     : {
    label: {
      type   : String,
      default: ''
    },
    labelClass: {
      type   : String,
      default: 'text-center'
    },
    chipClass: {
      type   : String,
      default: ''
    },
    chipStyle: {
      type   : [String, Object],
      default: ''
    },
    avatarClass: {
      type   : String,
      default: ''
    },
    iconClass: {
      type   : String,
      default: ''
    },
    color: {
      type   : String,
      default: ''
    },
    avatarColor: {
      type   : String,
      default: ''
    },
    icon: {
      type   : String,
      default: ''
    },
    iconOnly: {
      type   : Boolean,
      default: false
    },
    minWidth: {
      type   : [Number, String],
      default: undefined
    },
    dense: {
      type   : Boolean,
      default: false
    },
    xDense: {
      type   : Boolean,
      default: false
    },
    useContrastColor: {
      type   : Boolean,
      default: false
    },
    tooltip: {
      type   : String,
      default: ''
    },
    tooltipPosition: {
      type   : String,
      default: 'top'
    }
  },
  data() {
    return {}
  },
  computed: {
    isDense() {
      return this.dense || this.xDense
    },
    contrastColorStyle() {
      return this.useContrastColor ? `color: ${getContrastColor(this.color || '#666666', true, 135)}` : ''
    },
    chipMinWidth() {
      const minWidth = this.minWidth ? this.minWidth.toString().replaceAll('px', '') : '16'
      return {'min-width': `${minWidth}px`}
    },
    iconColor() {
      const color = this.avatarColor || this.color || 'white'
      // eslint-disable-next-line prefer-const
      let [colorName, colorModifier] = color.toString().trim().replace('-', '').split(' ', 2)
      colorModifier = 'lighten-5'
      return `${colorName} ${colorModifier}`
    },
    iconSize() {
      return this.dense ? 18 : this.xDense ? 14 : 22
    },
    avatarSize() {
      if (this.xDense) return `width: ${this.iconOnly ? 18 : 16}px !important; height: 32px !important;`
      if (this.dense) return `width: ${this.iconOnly ? 24 : 32}px !important; height: 32px !important;`

      return `width: ${this.iconOnly ? 32 : 46}px !important; height: 32px !important;`
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {getContrastColor}
}
</script>

<style scoped>
:deep(.v-chip > .v-chip__content) {
  width: 100%;
}
</style>
